import { COURSE_TYPES } from 'constants/common';

export const convertDataToApi = (data: any) => ({
  type: COURSE_TYPES.TRAINING,
  platform: data.platform.value,
  schoolId: data.school.value,
});
